import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../components/layout';
import Detalhes from '../components/Detalhes';
import Sobre from '../components/Sobre';
import Mentores from '../components/mentores';
import Local from '../components/Local';

export default class Index extends Component {
  render() {
    return (
      <Layout location="/">
        <Helmet
          htmlAttributes={{ lang: 'pt-BR' }}
          meta={[
            { name: 'description', content: 'Hackathon AgriTech - UniLaSalle/Lucas' },
            { name: 'keywords', content: 'agritech, agronegocio, gpsati, hackathon, lasalle, maratona, tecnologia, unilasalle' },
          ]}
          title="Hackathon AgriTech | UniLasalle/Lucas"
        />
        <Sobre />
        <Mentores />
        <Detalhes />
        <Local />
      </Layout>
    )
  }
}
